export default {
  state: {
    qudanList: [],
    qudanList_ids: [],
    qudanList_select_goods_num: 0,
    isIndeterminate: false,
    checkAll: false,
    qudanShow: false,
    piLiangKeyboard: false
  },
  mutations: {
    SET_QUDAN_STATE(state, payload) {
      Object.assign(state, payload)
    },
    RESET_QUDAN_STATE(state) {
      state.qudanList = []
      state.qudanList_ids = []
      state.qudanList_select_goods_num = 0
      state.isIndeterminate = false
      state.checkAll = false
      state.qudanShow = false
      state.piLiangKeyboard = false
    }
  },
  actions: {
    saveQudanState({ commit }, payload) {
			
      commit('SET_QUDAN_STATE', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/qudan.js